import { getCommissionProgressByCommPayType } from '../../api/commissionProgressApi';
import AccountantCommissionListWrapper from './accountantCommissionListWrapper';
import { Box } from '@mui/material';

const ASTERN_COLUMNS = [
    'salesId', 'depositDate', 'customer', 'agent', 'coAgent',
    'commission', 'progress', 'custProgress', 'status',
    'productCategory', 'productEnergy',
    'asternDiscount', 'agentDiscount', 'finalPrice',
    'firstPayment', 'firstPaymentDate', 'secondPayment', 'secondPaymentDate',
    'actions',
];

export default function AsternClaimList() {
    const apiCall = () => getCommissionProgressByCommPayType("Total Commission");

    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>Astern Claims</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>Total commission claims from Astern</p>
            </Box>
            <AccountantCommissionListWrapper
                apiCall={apiCall}
                visibleColumns={ASTERN_COLUMNS}
                showClaimExports
            />
        </div>
    );
}
